import { render, staticRenderFns } from "./SubjectAndFromSection.vue?vue&type=template&id=5d80d342&scoped=true"
import script from "./SubjectAndFromSection.vue?vue&type=script&lang=js"
export * from "./SubjectAndFromSection.vue?vue&type=script&lang=js"
import style0 from "./SubjectAndFromSection.vue?vue&type=style&index=0&id=5d80d342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80d342",
  null
  
)

export default component.exports